import MinhaConta from '../pages/Inicio/MinhaConta/Menu'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Menu'
import Usuarios from '../pages/Admin/Usuarios/Menu'
import ArtisticoLiterario from '../pages/Links/ArtisticoLiterario/Menu'
import AuxilioBrasil from '../pages/Servicos/AuxilioBrasil/Menu'
import Concursos from '../pages/Servicos/Concursos/Menu'
import Concursos2023 from '../pages/Servicos/Concursos2023/Menu'
import LegislacoesMunicipais from '../pages/Servicos/LegislacoesMunicipais/Menu'
import ControleInterno from '../pages/Servicos/ControleInterno/Menu'
import Fornecedores from '../pages/Servicos/Fornecedores/Menu'
import doem from '../pages/Servicos/doem/Menu'
import Licitacoes from '../pages/Servicos/Licitacoes/Menu'
import LicitacoesComunicados from '../pages/Servicos/Licitacoes-Comunicados/Menu'
import Convenios from '../pages/Servicos/Convenios/Menu'
import LeiAldirBlanc from '../pages/Links/LeiAldirBlanc/Menu'
import Pnab from '../pages/Links/Pnab/Menu'
import LeiPauloGustavo from '../pages/Links/LeiPauloGustavo/Menu'
import PPA from '../pages/Links/PPA/Menu'
import PME from '../pages/Links/PME/Menu'
import ProfessoresTemporarios from '../pages/Servicos/ProfessoresTemporarios/Menu'
import Servicos from '../pages/Servicos/Servicos/Menu'
import Vacinados from '../pages/Links/Vacinados/Menu'
import Legislacao from '../pages/Servicos/Legislacao/Menu'
import PregaoOnline from '../pages/Servicos/PregaoOnline/Menu'
import PlanejamentoSaude from '../pages/Links/PlanejamentoSaude/Menu'
import Banners from '../pages/Site/Banners/Menu'
import Destaques from '../pages/Site/Destaques/Menu'
import Galerias from '../pages/Site/Galerias/Menu'
import Noticias from '../pages/Site/Noticias/Menu'
import Prefeitos from '../pages/Site/Prefeitos/Menu'
import Paginas from '../pages/Links/Paginas/Menu'
import Secretarias from '../pages/Site/Secretarias/Menu'
import Videos from '../pages/Site/Videos/Menu'

const MenuDefault = [{
	titulo: 'Início',
	icone: 'menu-icon fa fa-tachometer',
	action: false,
	visualizar: false,
	submenu: [...MinhaConta]
},
{
	titulo: 'Site',
	icone: 'menu-icon fa fa-desktop',
	action: false,
	visualizar: false,
	submenu: [...Banners, ...Destaques, ...Galerias, ...Noticias, ...Prefeitos,  ...Secretarias, ...Videos]
},
{
	titulo: 'Links',
	icone: 'menu-icon fa fa-link',
	action: false,
	visualizar: false,
	submenu: [...ArtisticoLiterario, ...LeiAldirBlanc, ...LeiPauloGustavo, ...Paginas, ...PlanejamentoSaude, ...Pnab, ...PPA, ...PME, ...Vacinados]
},
{
	titulo: 'Serviços',
	icone: 'menu-icon fa fa-cogs',
	action: false,
	visualizar: false,
	submenu: [...AuxilioBrasil, ...Concursos2023, ...Concursos, ...ControleInterno, ...Convenios, ...doem, ...Fornecedores, ...Legislacao, ...LegislacoesMunicipais, ...Licitacoes, ...LicitacoesComunicados,  ...ProfessoresTemporarios, ...PregaoOnline, ...Servicos, ]
},
{
	titulo: 'Admin',
	icone: 'menu-icon fa fa-cog',
	action: false,
	visualizar: false,
	submenu: [...GrupoDeAcesso, ...Usuarios,]
}]

export default MenuDefault
